export default __webpack_public_path__ + "static/3-6fa040f56aee5fff1cb551ff49dac591.webp";